export class ScoreManager {
  private currentScore: number = 0;
  private bonusPoints: number = 0;
  private bestScoreAlici: number = 0;
  private bestScoreJasper: number = 0;
  private currentCat: 'alici' | 'jasper' = 'alici';
  private elapsedTime: number = 0;
  private isRunning: boolean = false;
  private pointsPerSecond: number = 10;
  private readonly STORAGE_KEY_ALICI = 'catdash_best_score_alici';
  private readonly STORAGE_KEY_JASPER = 'catdash_best_score_jasper';

  constructor() {
    this.loadBestScores();
  }

  private loadBestScores(): void {
    try {
      const aliciScore = localStorage.getItem(this.STORAGE_KEY_ALICI);
      const jasperScore = localStorage.getItem(this.STORAGE_KEY_JASPER);

      if (aliciScore !== null) {
        this.bestScoreAlici = parseInt(aliciScore, 10);
      }

      if (jasperScore !== null) {
        this.bestScoreJasper = parseInt(jasperScore, 10);
      }
    } catch (error) {
      console.error('Failed to load best scores from localStorage:', error);
    }
  }

  private saveBestScore(cat: 'alici' | 'jasper', score: number): void {
    try {
      const key = cat === 'alici' ? this.STORAGE_KEY_ALICI : this.STORAGE_KEY_JASPER;
      localStorage.setItem(key, score.toString());
    } catch (error) {
      console.error(`Failed to save best score for ${cat}:`, error);
    }
  }

  setCat(cat: 'alici' | 'jasper'): void {
    this.currentCat = cat;
  }

  start(): void {
    this.isRunning = true;
  }

  stop(): void {
    this.isRunning = false;

    const currentBestScore = this.currentCat === 'alici' ? this.bestScoreAlici : this.bestScoreJasper;

    if (this.currentScore > currentBestScore) {
      if (this.currentCat === 'alici') {
        this.bestScoreAlici = this.currentScore;
      } else {
        this.bestScoreJasper = this.currentScore;
      }
      this.saveBestScore(this.currentCat, this.currentScore);
    }
  }

  reset(): void {
    this.currentScore = 0;
    this.bonusPoints = 0;
    this.elapsedTime = 0;
    this.isRunning = false;
  }

  update(deltaTime: number): void {
    if (!this.isRunning) return;

    this.elapsedTime += deltaTime;
    const baseScore = Math.floor(this.elapsedTime * this.pointsPerSecond);
    this.currentScore = baseScore + this.bonusPoints;
  }

  addBonusPoints(points: number): void {
    this.bonusPoints += points;
  }

  getCurrentScore(): number {
    return this.currentScore;
  }

  getBestScore(): number {
    return this.currentCat === 'alici' ? this.bestScoreAlici : this.bestScoreJasper;
  }

  getBestScoreForCat(cat: 'alici' | 'jasper'): number {
    return cat === 'alici' ? this.bestScoreAlici : this.bestScoreJasper;
  }

  getElapsedTime(): number {
    return this.elapsedTime;
  }

  getFormattedTime(): string {
    const seconds = Math.floor(this.elapsedTime);
    const milliseconds = Math.floor((this.elapsedTime % 1) * 10);
    return `${seconds}.${milliseconds}s`;
  }
}
